const columns = [
  {
    title: '吃瓜入口',
    links: [
      { label: '今日大瓜', href: '#hot' },
      { label: '大图速览', href: '#feed' },
      { label: '实锤合集', href: '#truth' },
      { label: '往期盘点', href: '#timeline' },
    ],
  },
  {
    title: '黑料分线',
    links: [
      { label: '明星黑料', href: '#category' },
      { label: '网红黑料', href: '#category' },
      { label: '绯闻实锤', href: '#truth' },
      { label: '吃瓜热词', href: '#tags' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '爆料小组', href: '#top' },
      { label: '投稿流程', href: '#submit' },
      { label: '免责声明', href: '#submit' },
      { label: '联系我们', href: '#submit' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-white">黑料吃瓜</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              每日汇总明星黑料、网红黑料与绯闻实锤，把散落的线索拼成完整脉络。理性吃瓜，以上内容均为网络投稿汇总，不代表本站立场。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#submit" aria-label="投稿爆料" className="flex h-9 w-9 items-center justify-center rounded-md border border-white/20 text-background-100 hover:bg-white/10">
                <i className="ri-upload-cloud-2-line"></i>
              </a>
              <a href="#top" aria-label="返回顶部" className="flex h-9 w-9 items-center justify-center rounded-md border border-white/20 text-background-100 hover:bg-white/10">
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-bold text-white">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-background-300 hover:text-accent-400">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <span>© 2026 黑料吃瓜 · 吃瓜第一现场</span>
          <span className="whitespace-nowrap">内容仅供传播参考 · 理性围观</span>
        </div>
      </div>
    </footer>
  );
}